module.exports = __webpack_public_path__ + "static/media/15f594a8-becc-445f-bd90-b5f13deaff53.746fce3e.JPG";